export const FORGIVENESS_DETAIL_TITLE = 'Loan payment deferral';

export const FORGIVENESS_DETAIL = 'You won\'t have to make any principal or interest payments on your loan until after the SBA notifies us about your forgiveness amount. If your loan is not fully forgiven by the SBA or if you do not submit an application for forgiveness by the date that is ten months from 24 weeks after you receive your loan funds, we\'ll notify you about the due date and amount of your first payment.';

export const PPP_DETAIL = 'Find out more about the Paycheck Protection Program and loan forgiveness on our';

export const SBA_DECISION_STAGES = ['Declined', 'Forgiven', 'SBA Response Received'];

export const WEBSITE = 'website.';
